import React from 'react'
import {
	CallConnectedLazyRoute,
	BlockConnectedLazyRoute,
	SettingsConnectedLazyRoute,
	BlacklistConnectedLazyRoute,
} from 'Pages/coliseum'
import { Route, Switch } from 'react-router-dom'
import { FrontUrls } from 'Constants/FrontUrls'

export const ColiseumRoutes = () => {
	return (
		<Switch>
			<Route
				path={FrontUrls.coliseum.call}
				key={FrontUrls.coliseum.call}
				component={CallConnectedLazyRoute}
			/>
			<Route
				path={FrontUrls.coliseum.block}
				key={FrontUrls.coliseum.block}
				component={BlockConnectedLazyRoute}
			/>
			<Route
				path={FrontUrls.coliseum.settings}
				key={FrontUrls.coliseum.settings}
				component={SettingsConnectedLazyRoute}
			/>
			<Route
				path={FrontUrls.coliseum.blacklist}
				key={FrontUrls.coliseum.blacklist}
				component={BlacklistConnectedLazyRoute}
			/>
		</Switch>
	)
}
